<template>
    <div>
        <div class="row">
            <div class="col">
                <AgentSelection class="q-pa-md"/>
                <Navigation
                    class="q-px-md"
                    ShowNextButton=true
                    NextButtonColor="primary"
                    @NextButton="GoToTransactionConfirmation()"
                />
            </div>
        </div>
    </div>
</template>

<script>
import AgentSelection from '@/components/AgentSelection.vue'
import Navigation from '@/components/NavigationButtons.vue'
export default {
  name: 'AgentSelectionPage',
  components: {
    AgentSelection,
    Navigation
  },
  methods : {
      GoToTransactionConfirmation(){
      }
  }
}
</script>

